import styles from './index.module.scss';

export default function DialogBox({ onClose, children, style = {} }: { onClose: () => void; children: any; style?: any }) {
    return (
        <div className={styles.dialogBox}>
            <div className="dialog-box" style={style}>
                <div className="dialog-close" onClick={() => onClose()}></div>
                <div className="dialog-content">{children}</div>
            </div>
        </div>
    );
}
